import type { ApiClientCore } from './apiClient.core.js';
import type { AggregateObservabilityResponse, ApiResponse } from './apiClient.types.js';

export const aggregatesMethods = {
  /**
   * Read the aggregate engine observability snapshot:
   * worker lifecycle counters, recent materializations, drift alerts,
   * and the engine invariants the dev tab uses for didactic copy.
   * Capability: `dev:aggregates:read` (SUPER_DEV satisfies).
   */
  async getAggregateObservability(this: ApiClientCore): Promise<ApiResponse<AggregateObservabilityResponse>> {
    return this.get('/api/v1/dev/aggregates/observability', true);
  },

  /**
   * Manually materialize analytics rollups (sync 200 + DTO). Empty body
   * materializes yesterday UTC only. Capability: `dev:aggregates:run`.
   */
  async triggerAggregateMaterializationNow(
    this: ApiClientCore,
    body?: {
      from?: string;
      to?: string;
    }
  ): Promise<
    ApiResponse<{
      success: true;
      from: string;
      to: string;
      spanDays: number;
      processedDates: string[];
      funnelRowsWritten: number;
      commerceRowsWritten: number;
      snapshotRowsWritten: number;
      failedDates: string[];
      warnings: string[];
      durationMs: number;
      holderId: string;
    }>
  > {
    return this.post('/api/v1/dev/aggregates/run-now', body ?? {}, true);
  },
};
